// src/components/traceability/TopSpenderSummary.js

import React from 'react';
import { Clock, MapPin, Printer } from 'lucide-react';

const TopSpenderSummary = ({ data }) => {
  const handlePrint = () => {
    window.print();
  };

  if (!data) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 h-full flex items-center justify-center text-gray-400 text-xs">
        Sin datos
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:shadow-md transition-shadow h-full flex flex-col">
      {/* Header con título y botón de imprimir */}
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-base font-semibold text-gray-900">
          Unidad con mayor consumo
        </h3>
      </div>

      {/* Información del vehículo */}
      <div className="mb-4 pb-4 border-b border-gray-100 flex-1">
        <h4 className="font-semibold text-gray-900 text-sm mb-1 line-clamp-2">
          {data.vehiculo?.familia || 'N/A'} {data.vehiculo?.ano_modelo || ''}
        </h4>
        <p className="text-xs text-gray-500">
          Catálogo {data.vehiculo?.catalogo || 'N/A'} • VIN {data.vehiculo?.vin || 'N/A'}
        </p>
      </div>

      {/* Métricas en grid */}
      <div className="grid grid-cols-2 gap-3 mt-auto">
        {/* Distancia total */}
        <div className="bg-gradient-to-br from-indigo-50 to-indigo-100/50 rounded-lg p-3 border border-indigo-100">
          <div className="flex items-center gap-1.5 mb-2">
            <div className="p-1 bg-white rounded-md shadow-sm">
              <MapPin className="w-3.5 h-3.5 text-indigo-600" />
            </div>
            <span className="text-[10px] font-semibold text-indigo-700 uppercase tracking-wide">
              Distancia
            </span>
          </div>
          <p className="text-lg font-bold text-gray-900 mb-1">
            {data.totalDistance.toFixed(0)} km
          </p>
          <p className="text-[10px] text-gray-600 leading-tight">
            Recorrido total
          </p>
        </div>

        {/* Consumo Total (Replaces Time Away) */}
        <div className="bg-gradient-to-br from-red-50 to-red-100/50 rounded-lg p-3 border border-red-100">
          <div className="flex items-center gap-1.5 mb-2">
            <div className="p-1 bg-white rounded-md shadow-sm">
              <Clock className="w-3.5 h-3.5 text-red-600" /> {/* Keeping Clock icon or maybe changing to droplet if available, keeping Clock for now as 'Spending' implies time/resource or just generic */}
            </div>
            <span className="text-[10px] font-semibold text-red-700 uppercase tracking-wide">
              Consumo
            </span>
          </div>
          <p className="text-lg font-bold text-gray-900 mb-1">
            {data.totalConsumption.toFixed(1)} L
          </p>
          <p className="text-[10px] text-gray-600 leading-tight">
            Combustible usado
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopSpenderSummary;